import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import {
  DIAM_API_PATH,
  DiamModifierType,
  diamQueryKeys,
  getModifiers,
} from '../../diamApi';
import { useApiEssentials } from '../../../../shared/hooks/useApiEssentials';
import {
  mapAccountOptions,
  mapLocationTree,
  mapOptionalModifierFields,
} from './mapModifiers';

const MODIFIER_TYPES: DiamModifierType[] = ['account', 'location', 'expires'];

export function useCreateTeamModifiers(enabled: boolean) {
  const { getIdToken, apiUrl, isSignedIn } = useApiEssentials(DIAM_API_PATH);

  const modifiersQuery = useQuery({
    queryKey: diamQueryKeys.modifiers(MODIFIER_TYPES),
    queryFn: async () => {
      const idToken = await getIdToken();
      return getModifiers(apiUrl, idToken, MODIFIER_TYPES);
    },
    enabled: isSignedIn && enabled,
    retry: false,
    refetchOnWindowFocus: false,
  });

  const accountOptions = useMemo(
    () => mapAccountOptions(modifiersQuery.data?.modifiers),
    [modifiersQuery.data],
  );
  const locationTree = useMemo(
    () => mapLocationTree(modifiersQuery.data?.modifiers),
    [modifiersQuery.data],
  );
  const modifierFieldsConfig = useMemo(
    () => mapOptionalModifierFields(modifiersQuery.data?.modifiers),
    [modifiersQuery.data],
  );

  return {
    accountOptions,
    locationTree,
    modifierFieldsConfig,
    isLoading: modifiersQuery.isLoading,
    isError: modifiersQuery.isError,
    error: modifiersQuery.error,
  };
}
